var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_zip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_zip",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zip",
    d: "M3371.8,7162H3359v-16h8.229v4.7h4.571V7162Zm-5.387-6.747v3.724h.645v-1.384h.771a1.515,1.515,0,0,0,1.007-.3,1.062,1.062,0,0,0,.359-.852,1.094,1.094,0,0,0-.367-.859,1.431,1.431,0,0,0-.992-.325Zm-1.441,0v3.724h.645v-3.724Zm-1.44.523-1.925,2.782v.419h2.771v-.516h-1.99l1.929-2.8v-.41h-2.7v.523Zm4.3,1.3h-.778v-1.3h.8a.707.707,0,0,1,.507.183.649.649,0,0,1,.183.483.587.587,0,0,1-.182.469A.769.769,0,0,1,3367.836,7157.073Zm3.829-7.309h-3.521v-3.625l3.52,3.624Z",
    transform: "translate(-1922.4 -7129.002)",
    fill: "#e27330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZip);
export default __webpack_public_path__ + "static/media/ic_zip.7c5e88738d9e6c96f86244274e4aae5c.svg";
export { ForwardRef as ReactComponent };